{
  "$schema": "https://mux.run/theme.json",
  "name": "Cobalt2",
  "id": "cobalt2",
  "light": {
    "palette": {
      "neutral": "#ffffff",
      "ink": "#193549",
      "primary": "#0066cc",
      "accent": "#00acc1",
      "success": "#4caf50",
      "warning": "#ff9800",
      "error": "#e91e63",
      "info": "#ff5722"
    },
    "overrides": {
      "text-weak": "#5c6b7d",
      "syntax-comment": "#5c6b7d",
      "syntax-keyword": "#ff5722",
      "syntax-string": "#4caf50",
      "syntax-primitive": "#ff9800",
      "syntax-variable": "#193549",
      "syntax-property": "#00acc1",
      "syntax-type": "#00acc1",
      "syntax-constant": "#e91e63",
      "syntax-operator": "#ff5722",
      "syntax-punctuation": "#193549",
      "syntax-object": "#193549",
      "markdown-heading": "#ff9800",
      "markdown-text": "#193549",
      "markdown-link": "#0066cc",
      "markdown-link-text": "#00acc1",
      "markdown-code": "#4caf50",
      "markdown-block-quote": "#5c6b7d",
      "markdown-emph": "#ff5722",
      "markdown-strong": "#e91e63",
      "markdown-horizontal-rule": "#d3dae3",
      "markdown-list-item": "#0066cc",
      "markdown-list-enumeration": "#00acc1",
      "markdown-image": "#0066cc",
      "markdown-image-text": "#00acc1",
      "markdown-code-block": "#193549"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#193549",
      "ink": "#ffffff",
      "primary": "#0088ff",
      "accent": "#2affdf",
      "success": "#9eff80",
      "warning": "#ffc600",
      "error": "#ff0088",
      "info": "#ff9d00",
      "diffAdd": "#b9ff9f",
      "diffDelete": "#ff5fb3"
    },
    "overrides": {
      "text-weak": "#adb7c9",
      "syntax-comment": "#0088ff",
      "syntax-keyword": "#ff9d00",
      "syntax-string": "#9eff80",
      "syntax-primitive": "#ffc600",
      "syntax-variable": "#ffffff",
      "syntax-property": "#2affdf",
      "syntax-type": "#2affdf",
      "syntax-constant": "#ff628c",
      "syntax-operator": "#ff9d00",
      "syntax-punctuation": "#ffffff",
      "syntax-object": "#ffffff",
      "markdown-heading": "#ffc600",
      "markdown-text": "#ffffff",
      "markdown-link": "#0088ff",
      "markdown-link-text": "#2affdf",
      "markdown-code": "#9eff80",
      "markdown-block-quote": "#adb7c9",
      "markdown-emph": "#ff9d00",
      "markdown-strong": "#ff628c",
      "markdown-horizontal-rule": "#2d5a7b",
      "markdown-list-item": "#0088ff",
      "markdown-list-enumeration": "#2affdf",
      "markdown-image": "#0088ff",
      "markdown-image-text": "#2affdf",
      "markdown-code-block": "#ffffff"
    }
  }
}
